import { render } from "./PriceInquiryPageList.vue?vue&type=template&id=d8f55cec&scoped=true&ts=true"
import script from "./PriceInquiryPageList.vue?vue&type=script&lang=ts"
export * from "./PriceInquiryPageList.vue?vue&type=script&lang=ts"

import "./PriceInquiryPageList.vue?vue&type=style&index=0&id=d8f55cec&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8f55cec"]])

export default __exports__